import type { Config } from '../../_config'
import { DomainError } from '../../_kernel/DomainError'
import { ErrorsCode } from '../../_kernel/ErrorsCode'
import type { Affiliate } from '../domain/Affiliate'
import type { Language } from '../domain/Language'
import type { PartialSearch } from '../domain/PartialSearch'
import type { FeatureFlagInput, SharedRepository } from '../domain/SharedRepository'
import type { Source } from '../domain/Source'
import type { FeatureFlag } from '../domain/FeatureFlag'
import type { Market } from '../domain/Market'
import type { Platform } from '../domain/Platform'
import type { OperatingSystem } from '../domain/OperatingSystem'

export class ForbiddenSharedRepository implements SharedRepository {
  static create({ config }: { config: Config }) {
    return new ForbiddenSharedRepository(config)
  }

  constructor(protected readonly config: Config) {}

  async affiliate(): Promise<Affiliate> {
    throw DomainError.withCodes(ErrorsCode.FORBIDDEN_REPOSITORY_METHOD)
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async featureFlagByName({ name: _name }: FeatureFlagInput): Promise<FeatureFlag> {
    throw DomainError.withCodes(ErrorsCode.FORBIDDEN_REPOSITORY_METHOD)
  }

  async language(): Promise<Language> {
    throw DomainError.withCodes(ErrorsCode.FORBIDDEN_REPOSITORY_METHOD)
  }

  async market(): Promise<Market> {
    throw DomainError.withCodes(ErrorsCode.FORBIDDEN_REPOSITORY_METHOD)
  }

  async operatingSystem(): Promise<OperatingSystem> {
    throw DomainError.withCodes(ErrorsCode.FORBIDDEN_REPOSITORY_METHOD)
  }

  async partialSearch(): Promise<PartialSearch> {
    throw DomainError.withCodes(ErrorsCode.FORBIDDEN_REPOSITORY_METHOD)
  }

  async platform(): Promise<Platform> {
    throw DomainError.withCodes(ErrorsCode.FORBIDDEN_REPOSITORY_METHOD)
  }

  async source(): Promise<Source> {
    throw DomainError.withCodes(ErrorsCode.FORBIDDEN_REPOSITORY_METHOD)
  }
}
